module.exports = __webpack_public_path__ + "img/LOGO.ee164270.png";